import general from "../../../const/general";
import signed_files from "../../../const/signed_files";

// Redux Form passes the form props as the third validator argument.
const getLanguage = (props = {}) => props.language || (props.auth && props.auth.language) || 'es';

export const required = language => value =>  value ? undefined : general[language].required ;
export const commaequals = (value, allValues, props) => value && (value.includes(",") || value.includes("=")) ? general[getLanguage(props)].invalidCharacter : undefined;
export const requireden = (value, allValues, props) => value ? undefined : general[getLanguage(props)].required;
export const requiredlang = message => value => value ? undefined : message;
export const requiredNumber = (value, allValues, props) => value !== undefined ? undefined : general[getLanguage(props)].required;

export const maxLength = max => (value, allValues, props) =>
  value && value.length > max ? general[getLanguage(props)].maximumLength.replace('{0}', max) : undefined;

export const maxLengthEs = maxLength;

export const minLength = min => (value, allValues, props) =>
  value && value.length < min ? general[getLanguage(props)].minimumLength.replace('{0}', min) : undefined;

export const maxLength200 = maxLength(200);
export const maxLength20 = maxLength(20);
export const maxLengthEs50 = maxLengthEs(50);
export const maxLengthEs500 = maxLengthEs(500);
export const maxLengthEs200 = maxLengthEs(200);
export const maxLengthEs100 = maxLengthEs(100);

export const minLength10 = minLength(10);
export const minLength8 = minLength(8);

export const email = (value, allValues, props) =>  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? signed_files[getLanguage(props)].invalidMail : undefined;
export const emailes = email;
export const emaillang = message => value =>  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? message : undefined;